<!--
/**
* @Author: wulizhou
* @Description:
* @Date:
**/
-->

<template>
  <div class="ExchangeSuccessModal">
    <ModalMiddle v-if="isShow"
                 @close="isShow = false"
    >
      <div slot="ModalContent" class="ModalContent"
           :class="{ 'no-sub-header': subHead != '' }">
        <i class="iconfont3 icon-cz-get-circle-line"/>
        <div class="headline">{{ headline }}</div>
        <div class="sub-head" v-if="subHead">【 {{subHead}} 】</div>

        <CreatorBtn text="确定"
                    type="purple"
                    radius="25px"
                    width="140px"
                    height="40px"
                    fontSize="14px"
                    @handClick="isShow = false"
        ></CreatorBtn>
      </div>
    </ModalMiddle>
  </div>
</template>

<script>

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

/* 引入组件 */
import CreatorBtn from "@/components/_components/creator/CreatorBtn"

/* 引入VUEX */
import {mapState} from "vuex";

/* 引入API */

export default {
  name: "ExchangeSuccessModal"

  , components: {
    CreatorBtn
  }

  , props: {
    headline: {
      type: String,
      default: ""
    },
    subHead: {
      type: String,
      default: ""
    }
  }

  , watch: {}

  , computed: {}

  , data() {
    return {
      isShow: false
    }
  }

  , methods: {}

}
</script>

<style lang="scss" scoped>

.ModalContent {
  width: 440px;
  height: 276px;
  background: #FFFFFF;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;

  .icon-cz-get-circle-line {
    font-size: 44px;
    margin-bottom: 20px;
    color: rgba(105, 105, 255, 1);
    margin-top: 48px;
  }

  .headline {
    font-size: 20px;
    font-weight: bold;
    color: #424866;
    line-height: 26px;
    margin-bottom: 44px;

  }


  &.no-sub-header{
    .icon-cz-get-circle-line{
      margin-top: 40px;
    }

    .headline{
      margin-bottom: 10px !important;
    }

    .sub-head{
      font-size: 14px;
      color: #596088;
      line-height: 20px;
      margin-bottom: 40px;
    }
  }
}

</style>
